export default "__VITE_ASSET__Ds1HdZ8k__"